import React from 'react';

export const SantaSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="176.36"
    height="220.489"
    viewBox="0 0 176.36 220.489">
    <g id="Group_84" data-name="Group 84" transform="translate(-17.87 -21.586)">
      <path
        id="Path_7"
        data-name="Path 7"
        d="M88.9,212.568c38.473-.214,69.49-31.327,69.277-69.492S126.607,74.146,88.134,74.36s-69.49,31.327-69.277,69.492S50.43,212.782,88.9,212.568Z"
        fill="#ffa154"
      />
      <path
        id="Path_8"
        data-name="Path 8"
        d="M101.875,157.045c1.008-1.533-.973-3.228-2.743-2.748a45.565,45.565,0,0,1-11.552,1.357,46.694,46.694,0,0,1-10.918-1.193c-1.693-.418-3.372,1.164-2.406,2.619a16.737,16.737,0,0,0,27.618-.035Z"
        fill="#282f33"
        fill-rule="evenodd"
      />
      <path
        id="Path_9"
        data-name="Path 9"
        d="M80.785,161.686c1.188,1.479,4.789,1.9,7.2,1.9a14.537,14.537,0,0,0,7.275-1.9S87.323,159.084,80.785,161.686Z"
        fill="#d84c42"
      />
      <path
        id="Path_10"
        data-name="Path 10"
        d="M129.47,130.685a26.488,26.488,0,0,0-29.934-.176,20.964,20.964,0,1,1,29.936.176Z"
        fill="#f9f3eb"
      />
      <path
        id="Path_11"
        data-name="Path 11"
        d="M119,126.365a26.77,26.77,0,0,0-8.93-.052,11.334,11.334,0,1,1,8.931.052Z"
        fill="#282f33"
      />
      <path
        id="Path_12"
        data-name="Path 12"
        d="M119.885,115.041a5.442,5.442,0,1,0-5.442-5.442A5.442,5.442,0,0,0,119.885,115.041Z"
        fill="#fff"
      />
      <path
        id="Path_13"
        data-name="Path 13"
        d="M106.873,127.04a3.88,3.88,0,1,1,6.34-1.053,26.458,26.458,0,0,0-6.339,1.052Z"
        fill="#fff"
      />
      <path
        id="Path_14"
        data-name="Path 14"
        d="M99.636,135.144a7.772,7.772,0,0,1-.229-1.855c0-2.848,1.579-5.525,4.447-7.539a20.019,20.019,0,0,1,21.471,0c2.868,2.014,4.447,4.691,4.447,7.539a7.689,7.689,0,0,1-.228,1.85,10.606,10.606,0,0,0-5.137-6.276,20.328,20.328,0,0,0-19.632,0,10.595,10.595,0,0,0-5.139,6.281Z"
        fill="#db5443"
      />
      <path
        id="Path_15"
        data-name="Path 15"
        d="M74.317,130.685a26.488,26.488,0,0,0-29.934-.176,20.964,20.964,0,1,1,29.936.176Z"
        fill="#f9f3eb"
      />
      <path
        id="Path_16"
        data-name="Path 16"
        d="M63.842,126.365a26.77,26.77,0,0,0-8.93-.052,11.334,11.334,0,1,1,8.931.052Z"
        fill="#282f33"
      />
      <path
        id="Path_17"
        data-name="Path 17"
        d="M64.732,115.041A5.442,5.442,0,1,0,59.29,109.6,5.442,5.442,0,0,0,64.732,115.041Z"
        fill="#fff"
      />
      <path
        id="Path_18"
        data-name="Path 18"
        d="M51.72,127.04a3.88,3.88,0,1,1,6.34-1.053,26.462,26.462,0,0,0-6.339,1.052Z"
        fill="#fff"
      />
      <path
        id="Path_19"
        data-name="Path 19"
        d="M44.483,135.144a7.762,7.762,0,0,1-.229-1.855c0-2.848,1.579-5.525,4.447-7.539a18.785,18.785,0,0,1,10.735-3.122,18.788,18.788,0,0,1,10.736,3.122c2.868,2.014,4.447,4.691,4.447,7.539a7.658,7.658,0,0,1-.228,1.85,10.606,10.606,0,0,0-5.137-6.276,20.328,20.328,0,0,0-19.632,0,10.594,10.594,0,0,0-5.139,6.281Z"
        fill="#db5443"
      />
      <path
        id="Path_20"
        data-name="Path 20"
        d="M22.343,125.233S21.752,138.46,37.932,142.3s24.4-1.713,49.131-1.713,28.788,4.559,45.716,1.713,24.214-8.167,24.214-8.167,4.221,7.967-1.814,29.75-19.727,49.64-20.743,49.6-3.843-7.72-3.843-7.72A181.4,181.4,0,0,1,113.012,225.5c-9.653,9.177-19.546,16.617-20.583,16.578s-10.2-5.977-15.931-9.944-6.645-5.067-6.645-5.067-.6,2.151-1.3,2.608-8.579-2.635-16.978-10.753-17.009-19.883-17.009-19.883-1.8,4.494-2.647,4.429S27.209,194.3,23.7,182.7c-2.38-7.858-3.616-16.99-4.617-25.165C16.685,137.972,22.343,125.233,22.343,125.233Z"
        fill="#bcbcbc"
      />
      <path
        id="Path_21"
        data-name="Path 21"
        d="M22.343,121.233S21.752,134.46,37.932,138.3s24.4-1.713,49.131-1.713,28.788,4.559,45.716,1.713,21.952-12.235,21.952-12.235,1.818,12.5-3.267,33.569S133.8,205.839,132.781,205.8s-2.906-6.333-2.906-6.333a252.606,252.606,0,0,1-18.936,20.627c-9.653,9.177-20.049,15.53-21.087,15.49S82.3,233,75.594,228.508s-8.129-5.713-8.129-5.713.7,4.1,0,4.554-7.372-3.341-15.771-11.459-17.826-21.012-17.826-21.012-1.211,5.14-2.061,5.074-5.125-8.038-8.638-19.638c-2.38-7.858-3.758-17.156-4.758-25.332C16.017,135.424,22.343,121.233,22.343,121.233Z"
        fill="#fff"
      />
      <path
        id="Path_22"
        data-name="Path 22"
        d="M56.988,144.88h62.149a30.354,30.354,0,0,1-30.311,28.731h-.767A31.164,31.164,0,0,1,57.026,145.29Z"
        fill="#282f33"
      />
      <path
        id="Path_23"
        data-name="Path 23"
        d="M70.265,163.45c2.844,3.858,11.119,6.705,18.66,6.73,13.84.047,18.547-6.73,18.547-6.73S87.578,148.847,70.265,163.45Z"
        fill="#d84c42"
      />
      <path
        id="Path_24"
        data-name="Path 24"
        d="M41,74.607s.909-33.04,27.8-43.413,43.993-12.438,63.674-5.752,31.349,22.46,35.673,31.639,5.041,23.77,3,36.7-8.131,10.272-5.434,27.628,6.8,14.617,6.8,18.573-5.47,1.871-11.381-1.075-7.661-3.235-11.822-5.787-6.875-8.5-11.4-21.464-5.438-47.431-5.438-47.431Z"
        fill="#c61f13"
      />
      <path
        id="Path_25"
        data-name="Path 25"
        d="M132.473,25.442c19.681,6.686,31.349,22.46,35.673,31.639s5.041,23.77,3,36.7-8.131,10.272-5.434,27.628,6.8,14.617,6.8,18.573-9.917-2.69-12.542-22.245,8.476-28,2.041-55.978C155.569,33.727,132.473,25.442,132.473,25.442Z"
        fill="rgba(82,21,17,0.91)"
      />
      <path
        id="Path_26"
        data-name="Path 26"
        d="M44.717,56.283S48.54,50.421,70.6,52.309s61.136,9.957,62.352,11.527,2.6,37.97,2.6,37.97S131.563,88.592,89.9,86.851s-48.613,10.776-53.246,9.97.847-15.535,2.288-25.147a36.707,36.707,0,0,1,5.77-15.391Z"
        fill="#fff"
      />
      <path
        id="Path_27"
        data-name="Path 27"
        d="M178.23,160.414a16,16,0,1,0-16-16A16,16,0,0,0,178.23,160.414Z"
        fill="#fff"
      />
      <path
        id="Path_28"
        data-name="Path 28"
        d="M178.229,160.414a15.971,15.971,0,0,1-12.27-5.73,16,16,0,0,0,22.539-22.54,16,16,0,0,1-10.269,28.27Z"
        fill="rgba(0,0,0,0.26)"
      />
      <path
        id="Path_29"
        data-name="Path 29"
        d="M129.893,62.7a8.135,8.135,0,0,1,3.058,1.137c1.216,1.57,2.6,37.97,2.6,37.97s-3.223-3.569-4.256-4.909C135.211,97.969,132.914,65.085,129.893,62.7Z"
        fill="#bcbcbc"
      />
    </g>
  </svg>
);

export default SantaSvg;
